var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import { Typography, OutlinedInput } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import messages from 'translations/shared';
export var Search = function () {
    var formatMessage = useIntl().formatMessage;
    return (_jsx(OutlinedInput, { "data-cypress": "sidebar-search", placeholder: formatMessage(messages.sidebarSearch), startAdornment: _jsx(SearchIcon, {}, void 0), endAdornment: _jsx(Typography, __assign({ variant: "text-sm", color: "textSecondary" }, { children: "\u2318^F" }), void 0), inputProps: {
            'aria-label': 'search',
            style: {
                paddingLeft: 4,
                paddingRight: 4,
            },
        }, sx: {
            height: 40,
        }, size: "small" }, void 0));
};
